import { useRouter } from 'next/router';

export default function useNavigateSection() {
  const { push } = useRouter();

  const handleNavigate = (url: string) => {
    push(url);
  };

  return {
    handleNavigate,
  };
}
